import { render, staticRenderFns } from "./TablePaginatedOrderPricing.vue?vue&type=template&id=f5d0f3fa&scoped=true"
import script from "./TablePaginatedOrderPricing.vue?vue&type=script&lang=js"
export * from "./TablePaginatedOrderPricing.vue?vue&type=script&lang=js"
import style0 from "./TablePaginatedOrderPricing.vue?vue&type=style&index=0&id=f5d0f3fa&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d0f3fa",
  null
  
)

export default component.exports